export const VersionsTableHeaders = [
  "version-number",
  "created-date",
  "delete",
];
